import { render, staticRenderFns } from "./labelInfoRichText.vue?vue&type=template&id=4af97b44&scoped=true"
import script from "./labelInfoRichText.vue?vue&type=script&lang=js"
export * from "./labelInfoRichText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af97b44",
  null
  
)

export default component.exports